import moment from 'moment-jalaali';

// Set locale to Persian
moment.loadPersian({ usePersianDigits: true });

const ShamsiDate = ({ dateTime }) => {
  // Normalize the datetime string to a consistent format
  const formattedDateTime = dateTime.split('.')[0]; // Remove fractional seconds

  // Convert the datetime to Jalali (Shamsi) format
  const jalaliDate = moment(formattedDateTime).format('jYYYY/jMM/jDD HH:mm:ss');
  
  return <div>{jalaliDate}</div>;
};

export default ShamsiDate;